import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
}))

export default useStyles
